/**
 * Custom Wheel Scrolling for Splide Carousels
 * HORIZONTAL SCROLLING ONLY - doesn't interfere with vertical page scroll
 */

(function() {
  'use strict';

  function addWheelScrollingToCarousel(id, splideInstance) {
    const carouselElement = document.getElementById(id);
    if (!carouselElement) return;

    // Skip if already has wheel handler
    if (carouselElement.hasAttribute('data-wheel-enabled')) return;
    carouselElement.setAttribute('data-wheel-enabled', 'true');

    let isScrolling = false;

    carouselElement.addEventListener('wheel', function(e) {
      // ONLY use horizontal scrolling (deltaX)
      const deltaX = e.deltaX;
      
      // Ignore if not scrolling horizontally
      if (Math.abs(deltaX) < 10) return;
      
      // Ignore if scrolling more vertically than horizontally
      if (Math.abs(e.deltaY) > Math.abs(deltaX)) return;

      // Check if hovering over carousel
      const rect = carouselElement.getBoundingClientRect();
      const isHovering = (
        e.clientX >= rect.left &&
        e.clientX <= rect.right &&
        e.clientY >= rect.top &&
        e.clientY <= rect.bottom
      );

      if (!isHovering) return;

      // Prevent multiple rapid scrolls
      if (isScrolling) return;

      e.preventDefault();
      isScrolling = true;

      // CORRECT DIRECTION: swipe left = next, swipe right = previous
      if (deltaX > 0) {
        splideInstance.go('>');
      } else {
        splideInstance.go('<');
      }

      // Reset scrolling flag after delay
      setTimeout(() => {
        isScrolling = false;
      }, 300);
    }, { passive: false });

    console.log('Wheel scrolling enabled for:', id);
  }

  function enableWheelScrolling() {
    if (!window.slideshows) return;

    // Add wheel listener to each carousel
    Object.entries(window.slideshows).forEach(([id, splideInstance]) => {
      addWheelScrollingToCarousel(id, splideInstance);
    });
  }

  // Run multiple times to catch dynamically loaded carousels
  function initWithRetries() {
    enableWheelScrolling();
    
    // Check again after delays (for dynamically loaded content)
    setTimeout(enableWheelScrolling, 500);
    setTimeout(enableWheelScrolling, 1000);
    setTimeout(enableWheelScrolling, 2000);
  }

  // Initialize after DOM loads
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWithRetries);
  } else {
    initWithRetries();
  }

  // Also watch for new slideshows being added
  const observer = new MutationObserver(() => {
    enableWheelScrolling();
  });

  // Start observing after DOM loads
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      observer.observe(document.body, {
        childList: true,
        subtree: true
      });
    });
  } else {
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

})();